import type { HelpFile } from '../../types/help'
import { RequestDetailTestIds } from '../../../testids/RequestDetailTestIds'

export const requestDetailHelp: HelpFile = {
  docPage: '/docs/observability/request-inspector',
  texts: {
    [RequestDetailTestIds.requestDetailPage]:
      'Eingehende HTTP-Anfrage im Detail — Zeitmessung, SQL-Aktivität und Aufrufbaum der ausgelösten Operationen.',
    [RequestDetailTestIds.cardTitleWaterfall]:
      'Wasserfalldiagramm mit allen nachgelagerten Spans entlang der Zeitachse.',
  },
}
